import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

interface Props {
    doNotGrow?: boolean;
}

export const LoginButton = ({ doNotGrow }: Props) => {
    const { instance } = useMsal();
    const handleLoginPopup = () => {
        /**
         * When using popup and silent APIs, we recommend setting the redirectUri to a blank page or a page
         * that does not implement MSAL. Keep in mind that all redirect routes must be registered with the application
         * For more information, please follow this link: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations
         */
        instance
            .loginPopup({
                ...loginRequest,
                redirectUri: "/redirect"
            })
            .catch(error => console.log(error));
    };
    return (
        <a className="eq-primary-button w-fit" onClick={handleLoginPopup}>
            <span className="">
                <span>Login</span>
            </span>
        </a>
    );
};
